import { render, staticRenderFns } from "./matchPeriod.vue?vue&type=template&id=6f1babab"
import script from "./matchPeriod.vue?vue&type=script&lang=js"
export * from "./matchPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports